

(function($) { "use strict";
    // block-donate
    if( $('.block-donate').length ) {

        $('[data-donate-amount]').click(function(){
            $('input.range-slider').val($(this).data('donate-amount'));
        })

        $('button.submit-donation').on('click', function(e) {
            $(this).attr('disabled','disabled');
        });

        $('spektrix-donate')
            .on('success', function(e) {
                //enable button again
                $('this').find('.submit-donation').removeAttr('disabled')
            })
            .on('fail', function(e) {
                //enable button again
                $('this').find('.submit-donation').removeAttr('disabled')
            })
        ;

        $('[data-display-donation-amount]').each(function(){
            let self = this;
            let observer = new MutationObserver(function(mutationRecords) {
                // Handle mutations
                if (Number($(self).text()) > 0) {
                    $(self).closest('spektrix-donate').find('button.submit-donation').removeAttr('disabled');
                    // console.log('content > 0, button enabled')
                } else {
                    $(self).closest('spektrix-donate').find('button.submit-donation').attr('disabled', 'disabled');
                    // console.log('content <= 0, button disabled')
                }
            });

            observer.observe(self,
                {  // options:
                    characterData: true, //necessary for the observer to run
                    childList: true //text node is child and we want to be notified when it changes.
                });
        });


    }
})(jQuery);


